import { useConfiguration } from './useConfiguration'

/**
 * Whether the current org has rolled out evaluation rubrics
 * (`features.evaluation_rubrics`).
 *
 * The one read of the rollout flag, shared by the Evaluation Rubrics page
 * (`useEvaluationRubricsEnabled`) and the call Evaluation Rubric Results panel
 * (`useRubricAnalysisAccess`) so the two cannot drift. Neither checks a role:
 * callers combine it with their own capability.
 */
export function useEvaluationRubricsRolledOut(): boolean {
  const { configuration, isPreviousOrgData } = useConfiguration()
  // During an org switch the config query serves the previous org's data under
  // the new org's id, so trusting it would carry one org's rollout into another.
  if (isPreviousOrgData) return false
  return configuration?.features?.evaluation_rubrics ?? false
}
